import { BudgetCategoryUnitOfMeasureBase } from './base/budget-category-unit-of-measure-base';

export class BudgetCategoryUnitOfMeasure extends BudgetCategoryUnitOfMeasureBase { }